/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { servicedate } from '../../ehr/subs/servicedate';
import { adjudication } from './adjudication';
import { anesthesia } from './anesthesia';
import { dental } from './dental';
import { dmerc } from './dmerc';
import { fileinformation } from './fileinformation';
import { formidentification } from './formidentification';
import { homeoxygen } from './homeoxygen';
import { referenceimmunization } from './referenceimmunization';
import { testresults } from './testresults';
import { toothinformation } from './toothinformation';
import { messagereference } from '../../messages/messagereference';
import { referenceidentification } from '../../ehr/subs/referenceidentification';
import { provider_reference } from '../../domain/provider_reference';
import { encounterprogressnotesreference } from '../../ehr/subs/encounterprogressnotesreference';
import { externaldatareference } from '../../ehr/subs/externaldatareference';

export class medicalservice extends IceEntity {
  medical_service_key: string = "";
  other_items_key: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  product_service_id_qualifier: string = "";
  code: string = "";
  modifier1: string = "";
  modifier2: string = "";
  modifier3: string = "";
  modifier4: string = "";
  price: number = 0.0;
  cost: number = 0.0;
  unit_code: string = "";
  quantity: number = 0.0;
  service_description: string = "";
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  referral_key: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  report_type_code: string = "";
  report_transmission_code: string = "";
  report_identification_code_qualifier: string = "";
  report_identification_code: string = "";
  tax_rate_key: string = "";
  total_tax_amount: number = 0.0;
  approved_amount: number = 0.0;
  postage_claimed_amount: number = 0.0;
  purchased_service_provider_reference_identification: string = "";
  purchased_service_amount: number = 0.0;
  total_amount: number = 0.0;
  service_type_code: string = "";
  facility_code: string = "";
  emergency_indicator: string = "";
  epsdt_indicator: string = "";
  family_planning_indicator: string = "";
  copay_status_code: string = "";
  copay_service_key: string = "";
  prescription_key: string = "";
  hospice_employee_code_category: string = "";
  hospice_employed_provider_indicator: string = "";
  hospice_indicator: string = "";
  provider_control_number: string = "";
  trans_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  cosmetic_option: boolean = false;
  ar_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  inc_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  sal_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  inv_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_ser_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_sup_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_inv_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  tax_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  sal_payable_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  tax_payable_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  src_key: string = "";
  service_option: boolean = false;
  medical_service_type: number = 0;
  additional_note: string = "";

  SVCDTS: servicedate[] = [];
  ADJUDS: adjudication[] = [];
  ANES: anesthesia[] = [];
  DENTS: dental[] = [];
  DMERCS: dmerc[] = [];
  FILEINFOS: fileinformation[] = [];
  FORMIDS: formidentification[] = [];
  HMOXYS: homeoxygen[] = [];
  VACS: referenceimmunization[] = [];
  TRESULTS: testresults[] = [];
  TEETHINFO: toothinformation[] = [];
  REFIDS: referenceidentification[] = [];
  PROS: provider_reference[] = [];
  MSGS: messagereference[] = [];
  NOTES: encounterprogressnotesreference[] = [];
  EDOCS: externaldatareference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "MEDICAL_SERVICE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SVCDTS") return true;
    else if (ColumnName == "ADJUDS") return true;
    else if (ColumnName == "ANES") return true;
    else if (ColumnName == "DENTS") return true;
    else if (ColumnName == "DMS") return true;
    else if (ColumnName == "FILEINFOS") return true;
    else if (ColumnName == "FORMIDS") return true;
    else if (ColumnName == "HMOXYS") return true;
    else if (ColumnName == "VACS") return true;
    else if (ColumnName == "TRESULTS") return true;
    else if (ColumnName == "TEETHINFO") return true;
    else if (ColumnName == "REFIDS") return true;
    else if (ColumnName == "PROS") return true;
    else if (ColumnName == "MSGS") return true;
    else if (ColumnName == "NOTES") return true;
    else if (ColumnName == "EDOCS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SVCDTS") return "SERVICE_DATE";
    else if (ColumnName == "ADJUDS") return "ADJUDICATION";
    else if (ColumnName == "ANES") return "ANESTHESIA";
    else if (ColumnName == "DENTS") return "DENTAL";
    else if (ColumnName == "DMS") return "DMERC";
    else if (ColumnName == "FILEINFOS") return "FILE_INFORMATION";
    else if (ColumnName == "FORMIDS") return "FORM_IDENTIFICATION";
    else if (ColumnName == "HMOXYS") return "HOME_OXYGEN";
    else if (ColumnName == "VACS") return "REFERENCE_IMMUNIZATION";
    else if (ColumnName == "TRESULTS") return "TEST_RESULTS";
    else if (ColumnName == "TEETHINFO") return "TOOTH_INFORMATION";
    else if (ColumnName == "REFIDS") return "REFERENCE_IDENTIFICATION";
    else if (ColumnName == "PROS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "MSGS") return "MESSAGE_REFERENCE";
    else if (ColumnName == "NOTES") return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";
    else if (ColumnName == "EDOCS") return "EXTERNAL_DATA_REFERENCE";

    return null;
  }

}

